module.exports = __webpack_public_path__ + "img/Predefined Data.c22d61ef.svg";